import { EventCard } from 'components/event-card';
import { PostCard } from 'components/post-card';
import { EventCardDataFragment } from 'lib/graphql-generated';
import Link from 'next/link';

interface Props {
  events: EventCardDataFragment[];
}
export const EventRecommendations = ({ events }: Props) => {
  return (
    <section className='[ order-4 ] w-full p-8 bg-green-very-light lg:order-5'>
      <div className='space-y-6 w-full max-w-screen-xl mx-auto flex flex-row flex-wrap'>
        <h2 className=' uppercase tracking-wide font-header text-2xl w-full  pb-4 md:pb-8'>
          Featured in events:
        </h2>

        <ul className='w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-12'>
          {events.map((event) => (
            <EventCard
              event={event}
              className='w-full max-w-sm mx-auto md:mx-0'
              key={event.id}
            />
          ))}
        </ul>
      </div>
      <hr className='mt-14 border-black border-2 max-w-screen-lg mx-auto' />
    </section>
  );
};
